import React from 'react'
import { formatDisplayShorthand } from '../../../../utils/formatDisplay'

export const ValueCell = ({ value }: any) => <span>${formatDisplayShorthand(value ?? 0)}</span>